// contexts/BrandContext.jsx
import React, { createContext, useState, useContext } from 'react';
import { BRANDS } from '../config/brands';

export const BrandContext = createContext();

export function BrandProvider({ children }) {
  const [brandId, setBrandId] = useState('iremedy');
  
  const brand = BRANDS[brandId];
  
  return (
    <BrandContext.Provider value={{ brand, brandId, setBrandId }}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBrand = () => useContext(BrandContext);